<template>
  <div class="strategy-manager page-box">
    <div class="page-content">
      <div class="content-header">
        <el-input
          placeholder="用户名/用户操作"
          style="width: 200px;margin-right: 10px"
          v-model="userKey"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              用户名
            </vs-th>
            <vs-th>
              用户操作
            </vs-th>
            <vs-th>
              请求方法
            </vs-th>
            <vs-th>
              请求参数
            </vs-th>
            <vs-th>
              执行时长(毫秒)
            </vs-th>
            <vs-th>
              IP地址
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td
                style="max-width: 100px"
              >
                {{tr.id}}
              </vs-td>
              <vs-td
                style="max-width: 100px"
              >
                {{tr.username}}
              </vs-td>
              <vs-td>
                {{tr.operation}}
              </vs-td>
              <vs-td
                style="max-width: 200px"
              >
                <span class="rap-normal">{{tr.method}}</span>
              </vs-td>
              <vs-td
                style="max-width: 600px"
              >
                <span class="rap-normal">{{tr.params}}</span>
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{tr.time}}
              </vs-td>
              <vs-td>
                {{tr.ip}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.createDate)}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {

  },
  data() {
    return {
      userKey: '',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/log/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
      }
      if(this.userKey){
        this.params.key = this.userKey;
      }

      return true;
    },

    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
